import React, { useState, useEffect } from 'react';
import './CustomDatePicker.css';

import 'dayjs/locale/ko';
import { DatePicker, ConfigProvider } from 'antd';
import dayjs from 'dayjs';
import locale from 'antd/es/locale/ko_KR';
import customParseFormat from 'dayjs/plugin/customParseFormat';

const CustomDatePicker = ({ placeholder, allowedMonths, date, setDate }) => {
    dayjs.extend(customParseFormat);
    const monthFormat = 'YYYY년 MM월';

    const handleMonthChange = (date) => {
        if (date) {
            const formattedDate = date.format('YYYY-MM');
            setDate(formattedDate);
        }
    };

    const currentMonth = dayjs().format('YYYY-MM');
    const allAllowedMonths = allowedMonths.length === 0
        ? []
        : [...allowedMonths, currentMonth].map(month => dayjs(month, 'YYYY-MM').startOf('month'));

    const disableMonths = (currentDate) => {
        if (allowedMonths.length === 0) {
            return false;
        }
        const selectedMonth = dayjs(currentDate).startOf('month');
        return !allAllowedMonths.some(allowedMonth => selectedMonth.isSame(allowedMonth));
    };

    useEffect(() => {
        const inputElement = document.querySelector('.calendarContainer .ant-picker-input > input');
        if (inputElement) {
            inputElement.classList.add('custom-default-value');
        }
    }, []);

    return(
        <ConfigProvider locale={locale}>
            <DatePicker
                className="calendarContainer"
                defaultValue={dayjs(date, monthFormat)}
                format={monthFormat}
                picker="month"
                onChange={handleMonthChange}
                placeholder={placeholder}
                disabledDate={disableMonths}
            />
        </ConfigProvider>
    );
};

export default CustomDatePicker;